const Divider = ({ className }) => {
  return <hr className={`border-t border-gray-300 m-4 ${className}`} />;
};

export default Divider;
